import {
    TEST,
    SET_AUTHORIZATION_STATUS,
    REGISTRATION_STARTED,
    REGISTRATION_SUCCESS,
    REGISTRATION_FAILURE,
    LOGIN_STARTED,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    FORGOT_PASSWORD_STARTED,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_FAILURE,
    RESET_PASSWORD_STARTED,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE,
    SET_INVITATION_CODE_STARTED,
    SET_INVITATION_CODE_SUCCESS,
    SET_INVITATION_CODE_FAILURE
} from "./types";


const initialState = {
    test: false,
    authorizationStatus: !!localStorage.getItem('tc-token'),
    registrationStarted: false,
    registration: false,
    registrationErr: false,
    loginStarted: false,
    login: false,
    loginErr: false,
    forgotPasswordStarted: false,
    forgotPasswordErr: false,
    resetPasswordStarted: false,
    resetPasswordErr: false,
    invitationCodeStatusStarted: false,
    invitationCodeStatus: false,
    invitationCodeStatusErr: false,
};

export function mainReducer(state = initialState, action) {
    switch (action.type) {
        case TEST:
            return {
                ...state,
                test: action.payload
            };
        case SET_AUTHORIZATION_STATUS:
            return {
                ...state,
                authorizationStatus: action.payload
            };
        case REGISTRATION_STARTED:
            return {
                ...state,
                registrationStarted: true
            };
        case REGISTRATION_SUCCESS:
            return {
                ...state,
                registration: action.payload,
                registrationStarted: false
            };
        case REGISTRATION_FAILURE:
            return {
                ...state,
                registrationErr: action.payload,
                registrationStarted: false
            };
        case LOGIN_STARTED:
            return {
                ...state,
                loginStarted: true
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                login: action.payload,
                loginStarted: false
            };
        case LOGIN_FAILURE:
            return {
                ...state,
                loginErr: action.payload,
                loginStarted: false
            };
        case FORGOT_PASSWORD_STARTED:
            return {...state, forgotPasswordStarted: true, forgotPasswordErr: false};
        case FORGOT_PASSWORD_SUCCESS:
            return {...state, forgotPasswordStarted: false, forgotPasswordErr: false};
        case FORGOT_PASSWORD_FAILURE:
            return {...state, forgotPasswordStarted: false, forgotPasswordErr: action.payload};
        case RESET_PASSWORD_STARTED:
            return {...state, resetPasswordStarted: true, resetPasswordErr: false};
        case RESET_PASSWORD_SUCCESS:
            return {...state, resetPasswordStarted: false, resetPasswordErr: false};
        case RESET_PASSWORD_FAILURE:
            return {...state, resetPasswordStarted: false, resetPasswordErr: action.payload};
        case SET_INVITATION_CODE_STARTED:
            return {
                ...state,
                invitationCodeStatusStarted: true
            };
        case SET_INVITATION_CODE_SUCCESS:
            return {
                ...state,
                invitationCodeStatus: action.payload,
                invitationCodeStatusStarted: false
            };
        case SET_INVITATION_CODE_FAILURE:
            return {
                ...state,
                invitationCodeStatusErr: action.payload,
                invitationCodeStatusStarted: false
            };
        default:
            return state;
    }
}

